var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('iframe',{attrs:{"width":"560","height":"315","src":_vm.field.link,"title":"YouTube video player","frameborder":"0","allow":"accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }